import { Box } from "@mui/material";
import Metrics from "components/common/Metrics";
import * as support from "components/summary/payments/Payments.support";
import { Breakdown } from "components/summary/payments/tables/AmountBreakdown";

const PaymentsSummaryCard = ({ boundLayers, paymentsMade }) => {
  const boundLayersCount = (boundLayers ?? []).length;
  const requiredTotal = support.totalNetDue(boundLayers);
  const receivedTotal = support.totalReceived(paymentsMade);
  const { outstanding, overpaid } = support.paymentBalance(
    requiredTotal,
    receivedTotal
  );

  const metrics = [
    { label: "Bound Layers", value: boundLayersCount },
    {
      label: "Total Due",
      tip: (
        <Breakdown
          breakdown={{
            lines: [
              {
                label: "Premium",
                value: support.totalNetPremium(boundLayers),
              },
              {
                label: "Adjustments",
                value: support.totalNetAdjustments(boundLayers),
              },
            ],
            total: requiredTotal,
          }}
        />
      ),
      value: requiredTotal,
      prefix: "$",
      dp: 2,
      smallDecimals: true,
    },
    {
      label: "Total Received",
      value: receivedTotal,
      prefix: "$",
      dp: 2,
      smallDecimals: true,
    },
    {
      label: "Outstanding",
      value: outstanding,
      prefix: "$",
      dp: 2,
      smallDecimals: true,
    },
    ...(overpaid > 0
      ? [
          {
            label: "Overpaid",
            tip:
              "More has been received than is due, for example after a returned premium, this amount may need to be refunded or credited",
            value: overpaid,
            prefix: "$",
            dp: 2,
            smallDecimals: true,
          },
        ]
      : []),
    support.paymentStatusMetric({
      totalDue: requiredTotal,
      outstanding,
      overpaid,
    }),
  ];

  return (
    <Box
      sx={{
        padding: "0.875rem 0.375rem",
        background: (theme) => theme.brand.gray[500],
        borderRadius: "0.625rem",
      }}
    >
      <Metrics metrics={metrics} />
    </Box>
  );
};

export default PaymentsSummaryCard;
